<template>
    <section class="app-main">

        <el-card shadow="hover">
            <el-table :data="tableData" @selection-change="handleChecked" empty-text="暂无角色" height="610"  style="width:100%;">
                 <el-table-column label="日期"  align="center">
                    <template slot-scope="scope">
                        <i class="el-icon-time"></i>
                        <span style="margin-left: 10px">{{ scope.row.updated_at }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="title"      label="名称"  align="center"   ></el-table-column>
                <el-table-column prop="describe"   label="描述"  align="center"   show-overflow-tooltip> </el-table-column>
                <el-table-column  align="center">
                    <template slot-scope="scope">
                            <m-img v-if="scope.row.pic_url" :src="scope.row.pic_url" />
                        </template>
                </el-table-column>
            </el-table>
            <el-pagination background @current-change="reloadData" layout="prev, pager, next, jumper" style="padding:15px" :total="total" :page-size="size"></el-pagination>
        </el-card>
       


    </section>
</template>


<script>
import { feedback } from '@/api/platform.js'
import MImg   from './../../../components/Image'
export default {
    components: { MImg },
    data() {
        return {
            tableData: [],
            page:1,
            size:20,
            total:0,
        }
    },
    methods: {
        // 获取栏目数据
        handleData(){
            let params = {
                page:this.page
            }
            feedback(params).then(res => {
                if(res){
                    this.tableData = res.data.data
                    this.total     = res.data.total
                    this.size      = res.data.per_page
                }
            })
        },
        reloadData(page){
            this.page = page
            this.handleData()
        },
        
    },
    created(){
        this.handleData();
    },
    activated() {
        this.handleData()
    },
}
</script>

<style lang="less" scoped>
    section{
        .top-btn {
            width: 80px;
            margin-right: 15px;
        }
        .line-item {
            margin-bottom: 20px;
        }
        .input-left {
            height: 40px;
            line-height: 40px;
        }
    }
</style>